// removed by extract-text-webpack-plugin
module.exports = {"this":"df8x2j9k4f94dyy64tmu5a3tb51aezd2r9nfk1qnh59e9gzqj511y67bv6werubn2kv84cq8q7axqbmamddx6pt1fkxegucdgkaf92-Buttons-module-this","this---right":"_4fevgxqrpb24e4uwf6b9b1c1t2y1tyrvnq5ymvearh1p1kbwrfuqhtsbxmmmh9y5zujvqvty61jhv1xdrmzzpc14ru8wtp9zx8yanhh-Buttons-module-this---right","this---split":"_2ydvn1hhxem2w87zzv55rmqjrdgxnb1tv6k2rcx8ky2yghq4sm9d7gk2ab9qsp6vja6mr6kpsjab848saxqnp5wcvnp8nrg35gy54q3-Buttons-module-this---split","item":"_492qc488yd6vm7hfgk44ccvs574b2f4jaxsd65cbrafv65cktwyd8rub9y5jdaexn98ury1ak51dqvgtsut3qjm2bbzszdbr7d42fcr-Buttons-module-item"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/Buttons.module.scss
// module id = 540
// module chunks = 0